import React, { useState, useEffect, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from '@mui/material/IconButton';
import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";
import SettingsIcon from "@mui/icons-material/Settings";
import BoltIcon from "@mui/icons-material/Bolt";
import Checkbox from "@mui/material/Checkbox";
import Timer from "./Timer.js";
import MenuTabs from "../MenuPage/MenuTabs.js";
import { motion, AnimatePresence } from "framer-motion";
import Dashboard from "./Dashboard.js";
import { defaultTasks, levels } from "./Constants.js";
import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import Help from "./Help.js";
import "./homepage.css";
// import FocusRetainer from "../AudioFiles/FocusRetainer.mp3";
import { limits, messages, colorThemes } from "../Constants/constants.js";
import {
  iconPopAnimation,
  iconPopAnimationSetting,
} from "./utilityFunctions.js";
const HomePage = () => {
  const [user, setUser] = useState(null);
  const [totalTime, setTotalTime] = useState(0);
  const [totalSavedTime, setTotalSavedTime] = useState(0);
  const [totalBooster, setTotalBooster] = useState(0);
  const [totalBreakTime, setTotalBreakTime] = useState(0);
  const [tasks, setTasks] = useState(defaultTasks);
  const [taskName, setTaskName] = useState("");
  const [estimatedTaskTimeInMin, setEstimatedTaskTimeInMin] = useState("");
  const [colorMode, setColorMode] = useState(true);
  const [isSettingOn, setIsSettingOn] = useState(false);
  const [isMenuOn, setIsMenuOn] = useState(false);
  const [isHelpOn, setIsHelpOn] = useState(false);
  const [initialUserInteraction, setInitialUserInteraction] = useState(false);

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const focusFirstInput = () => {
    inputRef1.current.focus();
  };
  const screenHeight = window.innerHeight;
  const maxHeight = screenHeight - 250; // Adjust 100 as needed for margins, paddings, etc.
  const screenWidth = window.innerWidth;
  // Calculate the maximum width for the container
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isShowScore, setIsShowScore] = useState(true);
  const [isDashboardEnabled, setIsDashboardEnabled] = useState(false);
  const [isSoundOn, setIsSoundOn] = useState(false);
  const [warningTimer, setWarningTimer] = useState(8);
  const [isTaskHighlighed, setIsTaskHighlighed] = useState(true);
  const [attentionGrabTimer, setAttentionGrabTimer] = useState("");
  const [rotation, setRotation] = useState(0);

  // Theme related here
  const currentThemeName = "classic";
  // const currentThemeName = "dark";
  const themeColors = colorThemes[currentThemeName];

  const addBreak = (e) => {
    iconPopAnimation(e);
    if (taskName == "Break") {
      setEstimatedTaskTimeInMin(String(Number(estimatedTaskTimeInMin) + 5));
    } else {
      setTaskName("Break");
      setEstimatedTaskTimeInMin("5");
    }
  };
  const addBooster = (e) => {
    iconPopAnimation(e);
    setTasks(
      tasks.map((task) => {
        const a = task;
        return task.remainingTime < 30
          ? {
              ...task,
              snoozeTimer:
                task.snoozeTimer < 600
                  ? task.snoozeTimer + 150
                  : task.snoozeTimer,
              boosterCount: task.boosterCount ? task.boosterCount + 1 : 1,
            }
          : task;
      })
    );
  };
  const playWarningSound = (soundName) => {
    if (isSoundOn) {
      const audio = new Audio(soundName); // Replace with your sound file path
      audio.play();
    }
  };

  // This code is use to prevent website reloading
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This prevents the page from reloading without warning
      event.preventDefault();
      event.returnValue = ""; // Standard way to trigger a confirmation dialog in modern browsers
    };

    // Add the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Parse bracketed list input like: [Read:10, Exercise:5, Break:1]
  const parseTaskListInput = (rawInput) => {
    if (!rawInput || typeof rawInput !== "string")
      return { ok: false, error: "Empty input" };

    // remove surrounding brackets if present and trim
    const trimmed = rawInput.trim().replace(/^\[|\]$/g, "").trim();
    if (!trimmed) return { ok: false, error: "Empty list" };

    // pattern: name:number(,name:number)*
    // Accept quoted or unquoted names; capture name up to first colon, then number
    const items = trimmed.split(/\s*,\s*/);
    const MAX_LIST_ITEMS = 99; // user requirement: list length < 100
    const MAX_NAME_LEN = 500; // per-task name character limit
    const MAX_TASK_MINUTES = 99; // per-task time limit in minutes
    if (items.length > MAX_LIST_ITEMS) {
      return {
        ok: false,
        error: `List too long. Maximum ${MAX_LIST_ITEMS} tasks allowed in a list.`,
      };
    }

    const parsed = [];
    for (const item of items) {
      const m = item.match(/^(.*?):\s*(\d+)$/);
      if (!m) {
        return { ok: false, error: "Invalid item format: " + item };
      }
      let name = m[1].trim();
      // strip surrounding quotes if present
      if ((name.startsWith("'") && name.endsWith("'")) || (name.startsWith('"') && name.endsWith('"'))) {
        name = name.slice(1, -1).trim();
      }
      if (name.length > MAX_NAME_LEN) {
        return { ok: false, error: `Task name too long (max ${MAX_NAME_LEN} chars): ${name}` };
      }
      const minutes = parseInt(m[2], 10);
      if (!(minutes > 0 && minutes <= MAX_TASK_MINUTES)) {
        return {
          ok: false,
          error: `Each task time must be a number > 0 and <= ${MAX_TASK_MINUTES} minutes.`,
        };
      }

      parsed.push({
        id: Math.random(),
        taskName: name.charAt(0).toUpperCase() + name.slice(1),
        estimatedTaskTime: minutes * 60,
        remainingTime: minutes * 60,
        completionTime: 0,
        isTaskRunning: false,
        isCompleted: false,
        isTaskOverdue: false,
        snoozeTimer: 0,
        taskScore: 0,
      });
    }

    return { ok: true, tasks: parsed };
  };

  // Detect whether current taskName is a bracketed list input: starts with '[' and ends with ']'
  const isListInput = (() => {
    try {
      const t = (taskName || "").trim();
      return t.startsWith("[") && t.endsWith("]");
    } catch (e) {
      return false;
    }
  })();

  // If user entered a list input, clear the single-time input to avoid confusion
  React.useEffect(() => {
    if (isListInput) {
      setEstimatedTaskTimeInMin("");
    }
  }, [isListInput]);

  const handleAddTask = (e) => {
    setRotation((prevRotation) => prevRotation + 90);
    if (!initialUserInteraction) {
      setInitialUserInteraction(true);
    }
    const customValidation =
      estimatedTaskTimeInMin <= limits.maxTimeLimit &&
      tasks.length < limits.maxTasksLimit;
    const isLastTaskBreak =
      tasks[tasks.length - 1]?.taskName.toLowerCase() == "break" &&
      taskName.toLowerCase() == "break";
    // detect list-style input and parse via helper
    const listParseResult = parseTaskListInput(taskName);
    if (listParseResult.ok) {
      setTasks([...tasks, ...listParseResult.tasks]);
      setTaskName("");
      setEstimatedTaskTimeInMin("");
      return;
    } else {
      // if list-like input was provided but invalid, show the error
      const looksLikeList = /\[|,|:/.test(taskName);
      if (looksLikeList && taskName.trim().length > 0) {
        alert(listParseResult.error || "Invalid list format.");
        return;
      }
    }

    if (
      taskName &&
      estimatedTaskTimeInMin &&
      customValidation &&
      !isLastTaskBreak
    ) {
      setTasks([
        ...tasks,
        {
          id: Math.random(),

          taskName: taskName.charAt(0).toUpperCase() + taskName.slice(1),
          estimatedTaskTime: parseInt(estimatedTaskTimeInMin) * 60,

          remainingTime: parseInt(estimatedTaskTimeInMin) * 60,
          complitionTime: 0,

          isTaskRunning: false,
          isCompleted: false,
          isTaskOverdue: false,
          snoozeTimer: 0,
          taskScore: 0,
        },
      ]);
      setTaskName("");
      setEstimatedTaskTimeInMin("");
    } else {
      if (isLastTaskBreak) {
        alert(
          messages.double_break_warning_messages[
            Math.floor(
              Math.random() * messages.double_break_warning_messages.length
            )
          ]
        );
      } else if (taskName && estimatedTaskTimeInMin > limits.maxTimeLimit) {
        alert(
          messages.task_time_limit_warning_messages[
            Math.floor(
              Math.random() * messages.task_time_limit_warning_messages.length
            )
          ]
        );
      } else if (tasks.length >= limits.maxTasksLimit) {
        alert(
          `You've reached the max task limit of ${limits.maxTasksLimit}! Clear some tasks to add more.`
        );
      } else {
        alert("Please enter task name and estimated task time.");
      }
    }
  };

  // This is for Attention Grab Timer
  useEffect(() => {
    let timer;

    if (parseFloat(attentionGrabTimer) > 0.1) {
      const delay = parseFloat(attentionGrabTimer) * 60 * 1000; // Convert minutes to milliseconds

      timer = setInterval(() => {
        console.log("Here is time", new Date());
        // playWarningSound(FocusRetainer);
      }, delay);
    }

    return () => clearInterval(timer); // Clean up the timeout on component unmount or if timer restarts
  }, [attentionGrabTimer]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.isTaskRunning
            ? {
                ...task,
                remainingTime: task.remainingTime - 1,
                snoozeTimer: task.snoozeTimer > 0 ? task.snoozeTimer - 1 : 0,
              }
            : task
        )
      );
    }, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const getUserLevel = (tasks, score) => {
    let activeCount = 0;
    let overdueTasks = 0;
    const totalTasks = tasks.length;

    tasks.forEach((task) => {
      activeCount += task.estimatedTaskTime - task.remainingTime;
      if (task.isTaskOverdue) overdueTasks++;
    });

    // Calculate overdue percentage
    const overduePercentage = (overdueTasks / totalTasks) * 100;

    // Determine the user's level
    for (const level of levels) {
      const {
        minActiveCount = 0,
        maxOverduePercentage = 100,
        minScore = 0,
      } = level.criteria;

      if (
        activeCount >= minActiveCount &&
        overduePercentage <= maxOverduePercentage &&
        score >= minScore
      ) {
        return level.name;
      }
    }

    // Default level if no criteria match
    return "";
  };
  const handleAddItem = (description) => {
    setTaskName(description);
    setIsMenuOn(false);
  };

  const addTasksToList = (preset) => {
    // console.log("Hellow addddtttr", preset, tasks);
    let temptaskslst = [];
    preset?.presetTasks?.map((task) => {
      temptaskslst.push({
        id: Math.random(),
        taskName: task.taskName,
        estimatedTaskTime: parseInt(task.estimatedTaskTime) * 60, // Convert minutes to seconds
        remainingTime: parseInt(task.estimatedTaskTime) * 60, // Same for remaining time
        completionTime: 0,
        isTaskRunning: false,
        isCompleted: false,
        isTaskOverdue: false,
        snoozeTimer: 0,
        taskScore: 0,
      });
    });
    const timeoutId = setTimeout(() => {
      setTasks([...tasks, ...temptaskslst]);
    }, 500);

    return () => clearTimeout(timeoutId);
    // setTasks([...tasks, ...temptaskslst]);
  };


  //  Level code end here
  const [isAnimating, setIsAnimating] = useState(false);
  const totalTasksScore = tasks.reduce((sum, task) => sum + task.taskScore, 0);

  useEffect(() => {
    console.log(taskName);
    const handleKeyPress = (event) => {
      if (event.key === "Escape") {
        // Focus on the first input
        focusFirstInput();
      }
      if (event.key === "Enter") {
        handleAddTask();
        focusFirstInput();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [estimatedTaskTimeInMin]);

  return (
    <div>
      {/* Entire Page */}
      <div
        style={{
          margin: "0 auto",
          textAlign: "center",
          width: "100vw",
          height: "100vh",
          backgroundColor: "white",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: themeColors.backgroundColor,
        }}
      >
        <span
          style={{ marginTop: "0px", color: colorMode ? "black" : "white" }}
        >
          {/* ... Craft */}
        </span>
        {isDashboardEnabled && (
          <Dashboard
            colorMode={colorMode}
            totalTime={totalTime}
            totalSavedTime={totalSavedTime}
            totalBooster={totalBooster}
            totalBreakTime={totalBreakTime}
          ></Dashboard>
        )}
        {/* Leves & score panel */}
        {!isDashboardEnabled && (
          <>
            <h1
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "2rem",
                color: "#333",
                fontWeight: "700",
                letterSpacing: "0.1rem",
                paddingTop: "20px",
                margin: "0px",
              }}
            >
              To Do List
              {/* lazy leap */}
            </h1>

            <div className="dashboard-dimensions" style={{ display: "flex" }}>
              <label className="label-animation">
                <span>
                  Level: {" "}
                  <span className="label-animation-level-name">
                    {getUserLevel(tasks, parseInt(totalTasksScore.toFixed(2)))}
                  </span>
                </span>
              </label>
              {isShowScore && (
                <>
                  <div
                    className="separator"
                    style={{
                      width: "1px",
                      height: "1rem",
                      backgroundColor: "#ccc", // Subtle separator
                    }}
                  ></div>
                  <label
                    style={{
                      fontSize: "0.9rem", // Small font size for minimal impact
                      color: "#aaa", // Subtle gray color
                      // display: "flex",
                      // alignItems: "center",
                      padding: "0.2rem 0.4rem", // Compact padding
                      letterSpacing: "0.1px", // Minimal letter-spacing
                    }}
                  >
                    <span style={{ fontSize: "0.8rem" }}>
                      Evaluation : {totalTasksScore.toFixed(2)}
                    </span>
                  </label>
                </>
              )}
            </div>
          </>
        )}
        {/* Input panel */}
        <div className="align-task-info-center">
          <input
            type="text"
            ref={inputRef1}
            placeholder="Enter Task Name"
            value={taskName}
            className="task-name-input"
            onChange={(e) => {
              const rawValue = e.target.value;
              // Limit input to limits.maxInputCharacters (1 lakh)
              const maxChars = limits.maxInputCharacters;
              const sanitizedValue = rawValue.slice(0, maxChars);
              if (rawValue.length > maxChars) {
                alert("Max character limit: " + maxChars);
              }
              setTaskName(sanitizedValue);
            }}
          />
          {!isListInput && (
            <input
              type="number"
              placeholder="Time"
              value={estimatedTaskTimeInMin}
              ref={inputRef2}
              className="task-time-input"
              onChange={(e) => {
                const value = Math.max(0, Math.min(99, Number(e.target.value))); // Clamp value between 0 and 99
                setEstimatedTaskTimeInMin(value);
              }}
            />
          )}

          <div
            className="add-task-icon"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colorMode
                ? "#e0e0e0"
                : "#333";
              e.currentTarget.style.boxShadow =
                "0px 0px 8px rgba(128, 128, 128, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = colorMode
                ? "#f0f0f0"
                : "#444";
              e.currentTarget.style.boxShadow =
                "0px 8px 12px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.1)";
            }}
          >
            <AddIcon
              onClick={handleAddTask}
              className="bolt-icon"
              style={{
                fontSize: "37px",
                color: colorMode ? "black" : "white",
                alignContent: "center",
                marginTop: "2px",
                transform: `rotate(${rotation}deg)`, // Apply the rotation
                transition: "transform .3s ease-in-out", // Smooth transition
              }}
            />
          </div>
        </div>
        {/* Icons panel */}
        <div style={{ marginTop: "10px" }}>
          <MenuOpenIcon
            onClick={(e) => {
              iconPopAnimation(e);
              setIsMenuOn(!isMenuOn);
              setIsHelpOn(false);
            }}
            style={{ fontSize: "32px", color: colorMode ? "black" : "white" }}
            className="bolt-icon"
          ></MenuOpenIcon>
          <EmojiFoodBeverageIcon
            onClick={addBreak}
            style={{ fontSize: "28px", color: colorMode ? "black" : "white" }}
          ></EmojiFoodBeverageIcon>

          <BoltIcon onClick={addBooster} className="bolt-icon"></BoltIcon>
          <SettingsIcon
            onClick={(e) => {
              iconPopAnimationSetting(e);
              setIsSettingOn(!isSettingOn);
              // Trigger animation
              setIsAnimating(true);

              // Remove the animation class after the animation duration (0.5s)
              setTimeout(() => setIsAnimating(false), 500);
            }}
            style={{ fontSize: "28px", color: colorMode ? "black" : "white" }}
            // className={isAnimating ? "icon-animation" : ""}
          ></SettingsIcon>
        </div>

        {/* Menu panel */}
        {isMenuOn && (
          <MenuTabs
            setTaskName={setTaskName}
            setIsMenuOn={setIsMenuOn}
            addTasksToList={addTasksToList}
            user={user}
            setUser={setUser}
            tasks={tasks}
          ></MenuTabs>
        )}

        {/* setting panel */}
        {isSettingOn && (
          <>
            <div
              className="background-overlay"
              onClick={() => setIsSettingOn(false)}
            ></div>
            <div
              className={`setting-panel ${
                isSettingOn ? "slide-in" : "slide-out"
              }`}
            >
              <h2 className="setting-header">Settings</h2>

              <div className="divider"></div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "22vh", // Full height of the viewport
                  overflowY: "auto", // Enables scrolling
                }}
              >
                {/* Checkbox for Dashboard Enable */}
                <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Activity Summary
                  </label>
                  <Checkbox
                    checked={isDashboardEnabled}
                    {...label}
                    onChange={(event) => {
                      setIsDashboardEnabled(event.target.checked);
                    }}
                  />
                </div>
                {/* Checkbox for Task Highlighter */}
                <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Highlight Overdue Tasks
                  </label>
                  <Checkbox
                    checked={isTaskHighlighed}
                    {...label}
                    onChange={(event) => {
                      setIsTaskHighlighed(event.target.checked);
                    }}
                  />
                </div>
                {/* Checkbox for Sound Enable */}
                {/* <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Sound Alerts
                  </label>
                  <Checkbox
                    checked={isSoundOn}
                    {...label}
                    onChange={(event) => {
                      setIsSoundOn(event.target.checked);
                    }}
                  />
                </div> */}
                {/* Checkbox for Show Enable */}
                <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Show Evaluation
                  </label>
                  <Checkbox
                    checked={isShowScore}
                    {...label}
                    onChange={(event) => {
                      setIsShowScore(event.target.checked);
                    }}
                  />
                </div>


                {/* Input for Warning Timer */}
                <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Countdown
                  </label>
                  <input
                    type="number"
                    value={warningTimer}
                    onChange={(e) => setWarningTimer(e.target.value)}
                    className="warning-input"
                  />
                </div>
                {/* Separator */}
                {/* Input for Attention Grab */}
                {/* <div className="setting-inputs">
                  <label style={{ marginRight: "10px", textAlign: "left" }}>
                    Attention Timer
                  </label>
                  <input
                    type="number"
                    value={attentionGrabTimer}
                    onChange={(e) => setAttentionGrabTimer(e.target.value)}
                    className="warning-input"
                  />
                </div> */}
              </div>
              {/* Close Button */}
              <div className="setting-actions">
                <button
                  onClick={() => {
                    setIsSettingOn(false);
                  }}
                  className="close-button"
                >
                  Close
                </button>
              </div>
            </div>
          </>
        )}
        {/* <div
          className="list-centered-container"
          style={{
            width: "30%", // 25% of the parent width
            height: "2px", // Thickness of the hidden line
            // backgroundColor: "transparent", // Make the line invisible
            boxShadow: "0 -1px 10px rgba(0, 0, 0, 0.9)", // Subtle downward shadow
          }}
        ></div> */}
        {/* Help Panel */}
        {/* {isHelpOn && (
          <Help
            onClose={() => {
              setIsHelpOn(false);
            }}
          ></Help>
        )} */}
        {/* List panel */}
        {!isMenuOn && !isHelpOn && (
          <div
            className="list-centered-container"
            style={{
              maxHeight: `${maxHeight}px`, // Keep maxHeight dynamic
            }}
          >
            {/* List Render */}

            <ul style={{ padding: "4px", margin: "5px" }}>
              <AnimatePresence>
                {tasks.map((task, index) => (
                  <motion.li
                    key={task.id}
                    initial={{ opacity: 0, y: -20 }} // Start from above and invisible
                    animate={{ opacity: 1, y: 0 }} // End in normal position with full opacity
                    exit={{ opacity: 0, y: 20 }} // Fade out and move down when removed
                    transition={{ duration: 0.3 }} // Smooth transition for the animation
                  >
                    <Timer
                      key={task.id}
                      taskIndex={index}
                      tasks={tasks}
                      setTasks={setTasks}
                      colorMode={colorMode}
                      totalTime={totalTime}
                      totalSavedTime={totalSavedTime}
                      totalBooster={totalBooster}
                      totalBreakTime={totalBreakTime}
                      setTotalTime={setTotalTime}
                      setTotalSavedTime={setTotalSavedTime}
                      setTotalBooster={setTotalBooster}
                      setTotalBreakTime={setTotalBreakTime}
                      isSoundOn={isSoundOn}
                      isTaskHighlighed={isTaskHighlighed}
                      warningTimer={warningTimer}
                      initialUserInteraction={initialUserInteraction}
                      setInitialUserInteraction={setInitialUserInteraction}
                      currentThemeName={currentThemeName}
                    />
                  </motion.li>
                ))}
              </AnimatePresence>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
